export let ExperimentParameterGroup;
(function (ExperimentParameterGroup) {
  ExperimentParameterGroup["Control"] = "control";
  ExperimentParameterGroup["Variant"] = "variant";
  ExperimentParameterGroup["Variant_A"] = "variant_a";
  ExperimentParameterGroup["Variant_B"] = "variant_b";
  ExperimentParameterGroup["Variant_C"] = "variant_c";
  ExperimentParameterGroup["Variant_D"] = "variant_d";
})(ExperimentParameterGroup || (ExperimentParameterGroup = {}));